import { render } from "./MessageCard.vue?vue&type=template&id=96443cea&ts=true"
import script from "./MessageCard.vue?vue&type=script&lang=ts"
export * from "./MessageCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__